import { api } from './api';

export const agentAuthAPI = {
  login: (credentials) => api.post('/auth/login', credentials),
  
  validateToken: (token) => api.post('/auth/validate-token', null, {
    headers: { Authorization: `Bearer ${token}` }
  }),
  
  logout: () => api.post('/auth/logout'),
};

export const agentAPI = {
  getAll: () => api.get('/agents'),
  getActive: () => api.get('/agents/active'),
  getById: (id) => api.get(`/agents/${id}`),
  create: (agent, password) => api.post('/agents', agent, {
    params: { password }
  }),
  update: (id, agent) => api.put(`/agents/${id}`, agent),
  changePassword: (id, passwords) => api.put(`/agents/${id}/password`, passwords),
  getPermissions: (id) => api.get(`/agents/${id}/permissions`),
  updatePermissions: (id, permissions) => api.put(`/agents/${id}/permissions`, permissions),
  deactivate: (id) => api.put(`/agents/${id}/deactivate`),
  activate: (id) => api.put(`/agents/${id}/activate`),
};